import(/* webpackMode: "eager", webpackExports: ["AppRouterI18nContext"] */ "/app/apps/web/app/AppRouterI18nProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CustomI18nContext"] */ "/app/apps/web/app/CustomI18nProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/react-inlinesvg/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useAtomsContext"] */ "/app/packages/platform/atoms/hooks/useAtomsContext.ts");
;
import(/* webpackMode: "eager", webpackExports: ["SplitButton"] */ "/app/packages/ui/components/button/SplitButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Tooltip"] */ "/app/packages/ui/components/tooltip/Tooltip.tsx");
